/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ReceiptTable from "./components/table";

export default function LostReceipt() {
  const { formId, formField } = form;
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box display="flex" flexDirection="column" pb={10} gap={3}>
        <Box textAlign="center">
          <Typography variant="h4" textTransform="uppercase">
            Báo cáo mất, cháy hỏng biên lai
          </Typography>
          {/* <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
            (dành cho tổ chức, cá nhân kinh doanh đặt in, tự in)
          </Typography> */}
        </Box>
        <Formik initialValues={initialValues} validationSchema={validation} onSubmit={handleSubmit}>
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form id={formId} autoComplete="off">
              <Fields
                formData={{
                  values,
                  touched,
                  formField,
                  errors,
                }}
              />

              <ReceiptTable
                formData={{
                  values,
                  touched,
                  formField,
                  errors,
                }}
                setFieldValue={setFieldValue}
              />
              <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
                  {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                </SoftButton>
              </SoftBox>
            </Form>
          )}
        </Formik>
      </Box>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { taxId, conpanyName, address, date } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={conpanyName.name}
            label={conpanyName.label}
            value={values.conpanyName}
            error={errors.conpanyName && touched.conpanyName}
            success={values.conpanyName?.toString().length > 0 && !errors.conpanyName}
          />
        </Grid>{" "}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>{" "}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            dateFormat={"H:i d-m-Y"}
            label={date.label}
            name={date.name}
            error={errors.date && touched.date}
            success={values.date?.toString().length > 0 && !errors.date}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
